import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tln-ats-logo',
  styleUrl: './ats-logo.component.less',
  templateUrl: './ats-logo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class AtsLogoComponent {}
